import React, { useState, useEffect, useRef } from 'react'
// import Card from '../../../CustomComponents/Card';
import DynamicCard from '../../../CustomComponents/DynamicHomeCard';
import { width } from "../../../CustomComponents/DynamicHomeCard/DynamicHomeCardStyles";
import { useTranslation } from 'react-i18next';
import { useSelector, useDispatch } from 'react-redux';
import * as yup from 'yup';
import Loader from '../../../CustomComponents/Loader';
import CustomTextInput from '../../../CustomComponents/CustomtextInput';
import MobileIcon from '../../../../assets/smi-kudzu-images/mobiel_icon_smiOne.png'
import  App_Store from '../../../../assets/images/iPhone.png';
import Play_Store from '../../../../assets/images/playStore.png';
import {
  GENERATE_EXISTING_PHONE_EMAIL_OTP,
  UPDATE_PHONE_NUMBER,
  GENERATE_UPDATE_EMAIL_OTP,
  GENERATE_UPDATE_ADDRESS_OTP,
  GET_USER_PROFILE_V2,
  GET_USER_PROFILE_LANGUGAGE_LIST,
  GET_USER_PROFILE_TIMEZONE_LIST,
  GENERATE_OTP_CHANGE_PIN, STATUS_SUCCESS_CODE,
  OTP_USERS, POST_UPDATE_USER_PROFILE,
  GOOGLE_PLACE_DETAILS_WITH_PLACE_ID,
  GOOGLE_PLACES_AUTO_COMPLETE,
  VERIFY_UPDATE_ADDRESS_OTP,
  SAVINGS_VALIDATE_SSN,
  CREATE_SAVINGS_ACCOUNT,
  GET_CARDHOLDER_CARDS,
  REGISTER_USER,
  CONTACT_US_URL,
  IDOLOGY_CAMEL_CASE,
  PROGRAM_CONTENT
} from '../../../../network/URLConstants';
import { GetApiHeadersWithBearer, PostRequest, GetRequest, GetApiHeadersWithOutBearer } from '../../../../network/NetworkUtils';
import { displayErrorMessage, displaySuccessMessage, parseGoogleLocationResponse, isEmailValid, validateMobileNumber, formatDateYYYYMMDD, LineBreaksSpan, addLineBreaks } from '../../../../utils';
import LineBreaks from '../../../../utils';
import { appTheme, retrieveData } from '../../../../helpers/utils/Utils';
import { personalFormatPhoneNumber } from '../../../../utils';
import HomeLayout from '../../../Layout/HomeLayout';
import HomeHeader from '../../../CustomComponents/HomeHeader';
import CustomDropdown from '../../../CustomComponents/CustomDropDown';
import Custom2FA from '../../../CustomComponents/Custom2FA';
// import DynamicCard from '../../CustomComponents/DynamicCard';
import { LOGIN_SESSION_KEY } from '../../../../Redux/reducers';
import Modal from '../../../CustomComponents/Modal';
import { set, useForm } from 'react-hook-form';
import { fetchConfigarationData } from '../../../../helpers/utils/Utils';
import CustomAlertModel from '../../../CustomComponents/CustomAlertModel';
// import address_update_Succss from '../../../../assets/images/address_update_Succss.png';
import address_update_Succss from '../../../../assets/images/address-updated.png';
import email_update_success from '../../../../assets/images/email_update_success.png';
import updatedphone_success from '../../../../assets/images/updatedphone_success.png';
import fb from '../../../../assets/images/fb.png';
import { useKeyDown } from '../../../../hooks/useKeyDown';
import { useLocation, useNavigate } from 'react-router-dom';
import PlacesAutocomplete, { geocodeByAddress, getLatLng, geocodeByPlaceId } from 'react-places-autocomplete';
import TwoFactTypeSelctionModal from "../../../CustomComponents/TwoFactTypeSelctionModal";
import ShowSSNPic from '../../../../assets/images/showpassword.png'
import HideSSNPic from '../../../../assets/images/hidepassword.png'
import { yupResolver } from '@hookform/resolvers/yup';
import Arrow from '../../../../assets/images/arrow.png';
import RegisterSuccessModal from '../RegisterSuccessModal';
import transactionErrorIcon from "../../../../assets/images/transfer-error.png"
import pendingfile from '../../../../assets/images/pendingfile.png'
import profileError from '../../../../assets/images/profileError.png'
import Check from '../../../../assets/images/Check.png';
import logFirebaseEvents from '../../../LogFirebaseEvents';
import ComparisonOffer from '../../../../kudzu_plus/components/Comparison offer';
import CustomModalPlus from '../../../../kudzu_plus/helpers/customModalPlus';
import MemnershipEnrollmentScreens from '../../../../kudzu_plus/components/membershipEnrollmentScreens';
import CustomCarousel from '../../../../kudzu_plus/helpers/customCarousel';
import Cookies from 'js-cookie';
import { getUserMembership } from '../../../../helpers/utils/Utils';
import { Suspense } from "react";
import { SMI_ONE_PERSONAL_INFO_SUBMIT } from '../../../../network/URLConstants';
import SmiOneRegistrationSuccessModal from '../SmiOneRegistrationSuccessModal';

const appConfigData = await fetchConfigarationData();



const FinalRegistrationThroughSSN = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { t } = useTranslation(); // Hook to access translation functions
  const cards = useSelector(state => JSON.parse(state.userCards));
  const [isLoading, setIsLoading] = useState(false);
  const accessTokenToApi = useSelector(state => state.accessToken);
  const personalInfo = useSelector(state => state.signUpPersonelInfo);
  const signUpReferralCode = useSelector(state => state.signUpReferralCode);
  const signUpAccessCode = useSelector(state => state.signUpAccessCode);
  const ssnScreenThrough = useSelector(state => state.ssnScreenThrough);
  const savingsTermsConditions = useSelector(state => state.savingsTermsConditions);
  const twoFactAuthenticationDone = useSelector(state => state.twoFactAuthenticationDone);
  //universities
  const studentEmailAddress = useSelector(state => state.studentEmailAddress);
  const studentUniversityCode = useSelector(state => state.studentUniversityCode);
  const studentUniversityName = useSelector(state => state.studentUniversityName);
  const graduationDate = useSelector(state => state.graduationDate);

  const [showModel, setShowModel] = useState(false);
  const [modelImage, setModelImage] = useState('')
  const selectedItem = cards?.[0]
  const userId = useSelector(state => state.userId);
  const [loading, setLoading] = useState(false)
  const [SSNBackupSecondary, setSSNBackupSecondary] = useState('')
  const signUpkudzuPlusTrue = useSelector(state => state.isSignUpKudzuplusTrue);
  const isSignUpKudzuplusTrueDataVal = useSelector(state => state.isSignUpKudzuplusTrueData);
  const signUpkudzuisTrialTrue = useSelector(state => state.isSignUpKudzuplusTrial);
   const isSignUpKudzuplusTrialVal = useSelector(state => state.isSignUpKudzuplusTrial);
  const welcomeCarouselSkipData = useSelector(state => state.welcomeCarouselSkipValue);
  const isFromSmiOne = useSelector((state) => state.fromSmiOne);
  const appThemeData = appTheme(signUpkudzuPlusTrue);
  const [successModalOpen, setSuccessModalOpen] = useState(false)
  const [appDownloadModal, setAppDownloadModal] = useState(false)
  
  

  const HighlightMsgStyles = "font-serif-pro modal-title lg:text-[32px] md:text-[28px] sm:text-[23px] text-[27px] lg:leading-[38px] md:leading-[32px] sm:leading-[30px] leading-[37px] font-normal text-[var(--modal-text-highlight)]  cursor-pointer";
  const HeaderMsgStyles = "font-serif-pro modal-title lg:text-[32px] md:text-[28px] sm:text-[23px] text-[27px] lg:leading-[38px] md:leading-[32px] sm:leading-[30px] leading-[37px] font-normal cursor-pointer pointer-events-none text-[var(--modal-text-heading-clr)]";
  const HeaderMsgStylesplus = "font-serif-pro modal-title lg:text-[32px] md:text-[28px] sm:text-[23px] text-[27px] lg:leading-[38px] md:leading-[32px] sm:leading-[30px] leading-[37px] font-normal cursor-pointer pointer-events-none text-white";
  const SubHeaderMsgStyles = "font-hanken-grotesk modal-title  md:text-[18px] sm:text-[14px] text-[16px] font-normal cursor-pointer pointer-events-none";
  const SubHeaderMsgStylesPlus = "font-hanken-grotesk modal-title  md:text-[18px] sm:text-[14px] text-[16px] font-normal cursor-pointer text-white";
  const HighlightMsgStylesPlus = "font-hanken-grotesk modal-title  md:text-[18px] sm:text-[14px] text-[16px] font-normal cursor-pointer text-[#94C3E8]";
  const InputStyles = "font-hanken-grotesk   px-4 lg:text-[16px] md:text-[15px] text-[14px] placeholder:font-semibold font-medium focus:outline-none w-full h-[60px]";
  const SubHeadingStyles = "w-[90%] md:w-full font-serif-pro modal-title sm:text-[18px] lg:text-[32px] md:text-[28px] text-[25px] sm:leading-[24px] lg:leading-[38px] md:leading-[33px] leading-[31px] font-normal text-[var(--modal-text-heading-clr)]";
  const FailSubHeaderMsgStyles = "md:w-[317px] sm:w-[257px] font-hanken-grotesk modal-title  md:text-[18px] sm:text-[14px] text-[16px] font-normal cursor-pointer";
  const summaryParagraphStyles =
    "font-hanken-grotesk modal-title text-white lg:text-[12px] md:text-[10px] sm:text-[6px] text-[8px] font-normal cursor-pointer pointer-events-none";
  const [highlightMsg, setHighlightMsg] = useState('')
  const [headerMsg, setheaderMsg] = useState('')
  const [subHeaderMsg, setSubHeaderMsg] = useState('')
  const [subHeadingForCarousel, setSubHeadingForCarousel] = useState('')
  const [btn1Exists, setBtn1Exists] = useState(false)
  const [btn2Exists, setBtn2Exists] = useState(false)
  const [btn1Text, setBtn1Text] = useState(false)
  const [btn2Text, setBtn2Text] = useState('')
  const [btn1TypeAcpt, setBtn1TypeAcpt] = useState(false)
  const [footerMsg, setFooterMsg] = useState('');
  const [isBorderNone, setisBorderNone] = useState(true);
  const [showErrorImg, setshowErrorImg] = useState(false);
  const [isCursorVisible, setCursorVisibility] = useState(false);
  const [showSSN, setShowSSN] = useState(true);
  const ssnRef = React.createRef();
  const [SSNoError, setSSNoError] = useState('');
  const [ssnBackup, setSSnBackUp] = useState('');
  const [isSSNValid, setIsSSNValid] = useState(false);
  const [isSSNTouched, setIsSSNTouched] = useState(false);
  const [termsAccepted, setTermsAccepted] = useState(false)
  const [infoMessage, setinfoMessage] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const location = useLocation();
  const checkbox1Ref = useRef(null);
  const button1Ref = useRef(null);
  const [isRegisterSucessModalOpen, setRegisterSucessModalModalOpen] = useState(false);
  const [cipStatus, setCipStatus] = useState('');
  const [isRegistered, setIsRegistered] = useState(false);
  const isB2c = useSelector(state => state.preferredIdentity);
  
  const [showPlusModal, setShowPlusModal] = useState(false);
  const [fullWidth, setFullWidth] = useState(false);
  const [footerButtonEnable, setFooterButtonEnable] = useState(false);
  const [allButtonsDisable, setAllButtonsDisable] = useState(false);
  const [summaryParagraph, setSummaryParagraph] = useState('');
  const [opacityValueLow, setOpacityValueLow] = useState(true);
  const [comparisonScreen, setComparisonScreen] = useState('');
  const [btn1BgColor, setBtn1BgColor] = useState("");
  const [carousel, setCarousel] = useState('');
  const [iskudzuPlusKey, setIsKudzuPlusKey] = useState(false);
  const [showCarouselScreenShow, setShowCarouselScreensShow] = useState(false);
  const loggedResponse = useSelector(state => JSON.parse(state.loggedInResponse));
  const userMembershipData = getUserMembership(loggedResponse)
  const [policyURL, setPolicyURL] = useState("");
  const [showAgreementsModel, setShowAgreementsModel] = useState(false);
  const smiOneUserId = useSelector(state => state.smiOneKudzuResponseData.userId);
  const migrationId = useSelector((state) => state.smiOneId);
  const smiOnePassword = useSelector(state => state.smiOneNewCreatedPassword);
  const smiOneSSN = useSelector(state => state.smiOneSSN);
  const providerIdentifier = useSelector(state => state.providerIdentifier);
  const provider = useSelector(state => state.provider);
  const emailFromProvider = useSelector(state => state.emailFromProvider); 
  const issuerURL = useSelector(state => state.issuerURL);
 const getAgreementsBasedOnType = async (selectedAgreementType) => {
    const deviceId = await retrieveData("updatedDeviceId");
    const headers = await GetApiHeadersWithBearer(deviceId, accessTokenToApi);
    setLoading(true);

    let finalUrl =
      PROGRAM_CONTENT +
      "?accountType=64&language=en&contentType=" +
      selectedAgreementType +
      "&programKey=200";
    var response = await GetRequest(finalUrl, headers);
    var responseObj = JSON.parse(response);
    setLoading(false);
    if (responseObj.ResponseCode == STATUS_SUCCESS_CODE) {
      setPolicyURL(responseObj.Response.Data);
     
    } else {
      setTimeout(() => {
        var arrMessages = responseObj.Messages;
        var message = arrMessages[0];
        var displayText = message.DisplayText;
        // setError(displayText)
      }, 500);
    }
  };


  // useEffect(() => {
  //     const handleKeyPress = (event) => {
  //         if (event.key === 'Enter') {
  //             const elements = [checkbox1Ref, button1Ref, ssnRef];
  //             const isAnyElementFocused = elements.some(ref => ref.current === document.activeElement);
  //             if (!isAnyElementFocused) { handleConfirm() }
  //         }
  //     };

  //     document.addEventListener('keydown', handleKeyPress);
  //     return () => {
  //         document.removeEventListener('keydown', handleKeyPress);
  //     };
  // }, []);

  const openRegisterSuccessModalOpen = () => {
    setRegisterSucessModalModalOpen(true);

  };

  const closeRegisterSuccessModal = () => {
    setRegisterSucessModalModalOpen(false);
    window.location.replace('/');
  };



  const [formValues, setFormValues] = useState({
    firstName: '',
    lastName: '',
    dob: '',
    address: '',
    apt_etc: '',
    ssn_no: ''
  });
  const [ssn, setSSN] = useState('')





  useEffect(() => {
    handleSSNValue(ssnBackup)
  }, [showSSN])
  function formatValue(value) {
    const formattedValue = value
      .replace(/\D/g, '')
      .replace(/(\d{3})(\d{2})(\d{1,2})/, '$1 - $2 - $3');

    return formattedValue;
  }

  function formatSecuredValue(value) {
    const securedValue = value
      .replace(/[^0-9•]/g, '')
      .replace(/((?:\d|.){3})((?:\d|.){2})((?:\d|.){1,2})/, '$1 - $2 - $3')
      .replace(/[0-9]/g, '•');

    return securedValue;
  }
  const validationSchema = yup.object().shape({
    ssn_no: yup.string().required('Social Security Number (SSN) is required')
  });
  const footerContent = () => {
    return (
      <div>
      </div>
    )

  }



  const onAcptBtnClick = async () => {
    setShowModel(false)
    if (btn1Text == t("join_waitlist")) {
      window.location.replace('https://www.kudzumoney.com')
      return null;

    }

    else if (cipStatus == 'Refer' || cipStatus == 'Success' || subHeaderMsg == t('please_contact')) {
      window.location.replace('/');
    }


  }
  const onCancelBtnClick = () => {
    setShowModel(false)
    window.location.replace('/');
    // navigate('/signup');
  }
  const closeModel = () => {
    setShowModel(false);
    window.location.replace('/');
  }

  const showAlertModal = (showModel, highlightMsg, headerMsg, subHeaderMsg, btn1Exists, btn2Exists, btn1Text, btn2Text, btn1TypeAcpt, modelImage) => {
    setShowModel(showModel)
    setHighlightMsg(highlightMsg)
    setheaderMsg(headerMsg)
    setSubHeaderMsg(subHeaderMsg)
    setBtn1Exists(btn1Exists)
    setBtn2Exists(btn2Exists)
    setBtn1Text(btn1Text)
    setBtn2Text(btn2Text)
    setBtn1TypeAcpt(btn1TypeAcpt)
    setModelImage(modelImage)
  }

  useEffect(() => { console.log('87451', ssnScreenThrough) }, [ssnScreenThrough])


  // useEffect(() => {
  //   return () => {
  //     const data = { welcomeCarouselSkipValue: false };
  //     dispatch({ type: 'WELOCME_CAROUSEL_SKIP', payload: data })
  //   }
  // }, [])
  
console.log("personalInfo", personalInfo)
 
  const finalApiHit = async (isKudzuplus) => {
    
    const deviceId = await retrieveData('updatedDeviceId');
    let headers = await GetApiHeadersWithOutBearer(deviceId);
    setIsLoading(true);
    if (!isFromSmiOne){
          let finalHitObj = personalInfo;
    finalHitObj.ssn = ssnBackup
    finalHitObj.sEmail = studentEmailAddress
    finalHitObj.universityCode = studentUniversityCode
    finalHitObj.university = studentUniversityName
    finalHitObj.graduationDate = graduationDate
    if (signUpReferralCode) finalHitObj.referralCode = signUpReferralCode;
    if (signUpAccessCode) finalHitObj.accessCode = signUpAccessCode;
    if(isKudzuplus && isSignUpKudzuplusTrueDataVal){
      finalHitObj.isKudzuPlus = true;
    }
   
    var response = await PostRequest(REGISTER_USER(userId,isB2c), finalHitObj, headers);
    let responseObj = JSON.parse(response);
    if (responseObj.ResponseCode === STATUS_SUCCESS_CODE) {
      global.inviteCode = null;
      setIsLoading(false);
      if (isKudzuplus) {
        const isKudzuPlusAccount = { kudzuPlusTrue: true };
        dispatch({ type: 'KUDZU_PLUS_TRUE', payload: isKudzuPlusAccount });
         const kudzuPlusSetForCookies = `kudzuPlusTrueFromCookies`;
          Cookies.set(kudzuPlusSetForCookies, true, { expires: 1825 });
      }else{
        const kudzuPlusSetForCookies = `kudzuPlusTrueFromCookies`;
              Cookies.remove(kudzuPlusSetForCookies);
    }
      setCipStatus(responseObj.Response.cipStatus);
      if (responseObj.Response.cipStatus == 'Success') {
        setIsRegistered(true);
        openRegisterSuccessModalOpen();
      } else if (responseObj.Response.cipStatus == 'Refer') {
        if (responseObj.Response.cipFlow == "SecureForm") {
          const cipData = responseObj.Response
          dispatch({ type: 'CIP_STATUS_REFER', payload: { cipReferResponse: cipData } });
          setIsRegistered(true);
          navigate('/CipDocumentUploadScreen')
        }
        else if (responseObj.Response.cipFlow == IDOLOGY_CAMEL_CASE) {
          navigate('/idology')
        }
        else {
          setIsRegistered(true);
          showAlertModal(true, t('thanks'), t('reviewing_profile'), t('notify_via_email'), true, false, t('login'), "", false, pendingfile);
        }
      }

    } else if (responseObj.ResponseCode === 4122) {
      setIsLoading(false);
      var arrMessages = responseObj.Messages;
      var messageObject = arrMessages[0];
      const message = messageObject.MessageOrField;
      if (message == 'AccountEnrollmentFailed') {
        setIsRegistered(true);
        setErrorMessage(message);
        showAlertModal(true, t('we_are_sorry'), t('unable_to_approve'), t('please_contact'), true, false, t('login'), '', false, profileError);
      } else {
        const displayText = messageObject.DisplayText;
        showAlertModal(true, t('oops_exclamation'), displayText, "", true, true, t('auth_tryAgain'), t('Cancel'), true,appThemeData.transferErrorMessage);
      }
    }
    else if (responseObj.ResponseCode === 4120) {
      setIsLoading(false);
      var arrMessages = responseObj.Messages;
      var messageObject = arrMessages[0];
      const message = messageObject.MessageOrField;
      if (message == 'SignUpFailed') {
        const displayText = messageObject.DisplayText;
        // setIsRegistered(true);
        setErrorMessage(message);
        showAlertModal(true, t('oops_exclamation'), displayText, t('please_join'), true, false, t('join_waitlist'), '', true, appThemeData.transferErrorMessage);
      } else {
        const displayText = messageObject.DisplayText;
        showAlertModal(true, t('oops_exclamation'), displayText, "", true, true, t('auth_tryAgain'), t('Cancel'), true, appThemeData.transferErrorMessage);
      }
    }

    else {
      setIsLoading(false);
      var arrMessages = responseObj.Messages;
      if (arrMessages.length > 0) {
        var messageObject = arrMessages[0];
        const message = messageObject.DisplayText;
        // const formattedMessage = "<span className='font-hanken-grotesk text-md leading-7 text-oops_error pr-2'>Oops! </span>" + message;
        // alert(message);
        setIsRegistered(true);
        setErrorMessage(message);
        showAlertModal(true, t('oops_exclamation'), message, "", true, true, t('auth_tryAgain'), t('Cancel'), true, appThemeData.transferErrorMessage);
      }
    }
    }
    else{
      //SMI  REGISTER API 
         setIsLoading(true);
            let headers = await GetApiHeadersWithOutBearer();
            var requestObj =   {
                "applicationId": appConfigData.CLIENT_ID,
                "language": "en",
                "username": personalInfo.username,
                "password": smiOnePassword,
                "firstName": personalInfo.firstName,
                "lastName": personalInfo.lastName,
                "PreferredName":personalInfo.preferredName,
                "ssn": smiOneSSN,
                "line1": personalInfo.line1 != null ? personalInfo.line1 : "",
                "line2": personalInfo.line2 != null ? personalInfo.line2 : "",
                "city":  personalInfo.city != null ? personalInfo.city : "",
                "state":  personalInfo.state != null ? personalInfo.state : "",
                "zipCode": personalInfo.zipCode != null ? personalInfo.zipCode : "",
                "migrationToken":migrationId,
                "isEsignAccepted":personalInfo.isEsignAccepted,
                "IsPrivacyPolicyAccepted":personalInfo.IsPrivacyPolicyAccepted,
                "IsCHAgreementAccepted":personalInfo.IsCHAgreementAccepted,
                "CreateSavings":personalInfo.CreateSavings
                // "providerId": "JKDHFDK57VDFVBFJ577",
                // "provider": "Google"
              }
              if (providerIdentifier != null && providerIdentifier != undefined) {
                requestObj.provider = provider
                requestObj.providerId = providerIdentifier;
                requestObj.issuerURL = issuerURL;
                requestObj.socialLoginEmail = emailFromProvider;
            }
            if (global.inviteCode != null && global.inviteCode != undefined) {
                requestObj.inviteCode = global.inviteCode
            }
              var response = await PostRequest(SMI_ONE_PERSONAL_INFO_SUBMIT(smiOneUserId), requestObj, headers);
            let responseObj = JSON.parse(response);
            if (responseObj.ResponseCode === STATUS_SUCCESS_CODE) {
                if (responseObj.Response.cipStatus == 'Success') {
                    setIsLoading(false);
                    setSuccessModalOpen(true)
                }
                else if (responseObj.Response.cipStatus == 'Refer') {
                    if (responseObj.Response.cipFlow == "SecureForm") {
                        const cipData = responseObj.Response
                        dispatch({ type: 'CIP_STATUS_REFER', payload: { cipReferResponse: cipData } });
                        setIsRegistered(true);
                        navigate('/CipDocumentUploadScreen')
                    }
                    else if (responseObj.Response.cipFlow == IDOLOGY_CAMEL_CASE) {
                        navigate('/idology')
                    }
                    else {
                        setIsRegistered(true);
                        showAlertModal(true, t('thanks'), t('reviewing_profile'), t('notify_via_email'), true, false, t('login'), "", false, pendingfile);
                    }
                }

            } else {
                setIsLoading(false);
                var arrMessages = responseObj.Messages;
                const messageObject = arrMessages[0];
                const message = messageObject.DisplayText;
                setErrorMessage(message);
                showAlertModal(true, t('oops_exclamation'), message, "", true, true, t('auth_tryAgain'), t('Cancel'), true, appThemeData.transferErrorMessage);
            }
    }
   
  };

  const alertModal = (showModel, highlightMsg, headerMsg, subHeaderMsg, modelImage) => {
    setHighlightMsg(highlightMsg)
    setheaderMsg(headerMsg)
    setShowModel(showModel)
    setSubHeaderMsg(subHeaderMsg)
    setModelImage(modelImage)
  }

  const toggleCursor = () => {
    setCursorVisibility(!isCursorVisible);
  };
  const togglePasswordVisibility = () => {
    setShowSSN(!showSSN);
  };
  const { register, formState: { errors }, setError, setValue, clearErrors, getValues } = useForm({
    mode: 'onTouched',
    resolver: yupResolver(validationSchema),
  });
  const handleSSNChange = (event) => {
    //debugger;
    clearErrors();
    const ssnNumber = event.target.value;
    // Remove all non-digit characters from the input
    const ssnNum = ssnNumber.replace(/[*-]/g, '').replace(/\D/g, '');
    // const ssnNum = ssnNumber.length != 9 ? ssnNumber.replace(/[*-]/g, '').replace(/\D/g, '') : ssnNumber;
    // const value = inputValue.replace(/\D/g, '')
    setSSnBackUp(ssnNum)
    handleSSNValue(ssnNum)
    clearErrors();
    setinfoMessage('');
    setIsSSNTouched(true)
    if (event.target.value.length < 10) { setSSNBackupSecondary(event.target.value.replace(' ', "").replace('-', "").replace(' ', "")) }
    // Remove dashes from the input 
    if (ssnNum.length === 9) {
      // setError('ssn_no', { type: 'manual', message: 'Social Security Number (SSN) should be 9 digits' });
      //return;
      clearErrors();
      setinfoMessage('');
      handleInputChange(event);
      setIsSSNValid(true)
      // validateSSN(ssnNum)
      // Update the form values
      // ValidateSSN(ssnNo, formValues); // Pass the SSN value and form values to the ValidateSSN function
    } else {
      setIsSSNValid(false)
    }
  };
  const handleInputChange = (event) => {
    clearErrors();
    setinfoMessage('');
    const { name, value } = event.target;
    setFormValues((prevValues) => ({
      ...prevValues,
      [name]: value
    }));
  };
  function handleSSNValue(value) {
    const formatted = showSSN ? formatSecuredValue(value) : formatValue(value)
    setSSN(formatted)
  }

 
  const handleConfirm = () => {
    debugger;
    logFirebaseEvents("SSN_Screen", "Continue_Clicked", "Continue_Clicked", "", "");
    if(welcomeCarouselSkipData && isSignUpKudzuplusTrueDataVal){
      showAlertModalPlus(true, '',isSignUpKudzuplusTrialVal ? t('Access_exclusive_features_and_benefits') : t('access_exclusive_features_and_benefits_with_kudzu_membership'),"", false, false, '', '', false, '', "", true, "", "", true, <ComparisonOffer handleComparisonScreen={isSignUpBenefitsAcceptClicked}  preLoginAgreement={handlePreLoginAgreement}
 />, true, false,'', <><p className={`${SubHeaderMsgStylesPlus}  mt-6`}>{t('Get_access_to_more_with_a_Kudzu+_membership')}</p><p className={HighlightMsgStylesPlus} onClick={handleCarousels}>{t('learn_more')}</p></> );
    }
    else{
    if (ssnBackup == '' || !isSSNValid) {
      // setError("ssn_no", "Please enter valid SSN no.")
  setError('ssn_no', {
  type: 'manual',
  message: isFromSmiOne
    ? 'This does not match the previously entered SSN.'
    : 'Please enter valid SSN.',
});
      // setinfoMessage(t('please_enter_valid_ssn')); 
      setErrorMessage(t(''));
      return;
    }
    // else if (ssnBackup != '' && (savingsTermsConditions == false)) { setinfoMessage(''); setErrorMessage(t(t('please_review_certify_under_penalty_of_perjury'))); }
    else if (isSSNValid) {

      if (termsAccepted && personalInfo?.CreateSavings) { finalApiHit(signUpkudzuPlusTrue) }
      else if (!termsAccepted && !personalInfo?.CreateSavings) { finalApiHit(signUpkudzuPlusTrue) }
      else {
        setErrorMessage(t('please_review_certify_under_penalty_of_perjury'))
      }
    }
  }
    // else if () {}

  }
  const handlePaste = (event) => {
    event.preventDefault();
    return false;
  };
  const showAlertModalPlus = (showPlusModal, highlightMsg, headerMsg, subHeaderMsg, btn1Exists, btn2Exists, btn1Text, btn2Text, btn1TypeAcpt, modelImage, carousel, isBorderNone, btn1BgColor, summaryParagraph, opacityValue, comparisonScreen, fullWidth, footerButtonEnable, allButtonsDisable,subHeadingForCarousel) => {
    setShowPlusModal(showPlusModal)
    setHighlightMsg(highlightMsg)
    setheaderMsg(headerMsg)
    setSubHeaderMsg(subHeaderMsg)
    setBtn1Exists(btn1Exists)
    setBtn2Exists(btn2Exists)
    setBtn1Text(btn1Text)
    setBtn2Text(btn2Text)
    setBtn1TypeAcpt(btn1TypeAcpt)
    setModelImage(modelImage)
    setBtn1Exists(btn1Exists)
    setBtn1Text(btn1Text)
    setCarousel(carousel)
    setisBorderNone(isBorderNone)
    setBtn1BgColor(btn1BgColor)
    setSummaryParagraph(summaryParagraph)
    setOpacityValueLow(opacityValue)
    setComparisonScreen(comparisonScreen)
    setFullWidth(fullWidth)
    setFooterButtonEnable(footerButtonEnable)
    setAllButtonsDisable(allButtonsDisable)
    setSubHeadingForCarousel(subHeadingForCarousel)
  }

  const welcomeCarouselSkipFalse = () =>{
    const data = { welcomeCarouselSkipValue: false };
    dispatch({ type: 'WELOCME_CAROUSEL_SKIP', payload: data })
  }

  const isSignUpBenefitsAcceptClicked = () =>{
    welcomeCarouselSkipFalse()
    const isSignKudzuplus = { isSignUpKudzuplusTrue: true };
    dispatch({ type: 'IS_SIGNUP_KUDZU_PLUS_TRUE', payload: isSignKudzuplus });
    if (isSignKudzuplus) {
      document.body.classList.add('dark-theme');
      document.body.classList.remove('light-theme');
    } else {
      document.body.classList.add('light-theme');
      document.body.classList.remove('dark-theme');
    }
    setIsKudzuPlusKey(true)
    setShowPlusModal(false)
      finalApiHit(isSignKudzuplus);
    // finalApiHit()
  }

  const handlePreLoginAgreement = async () => {
       setShowPlusModal(false)
       await getAgreementsBasedOnType("CoveredByKudzuPlusTerms");
       setShowAgreementsModel(true)
  }





  const handleTermsClick = async () =>{
    if (accessTokenToApi == undefined || accessTokenToApi == null) {
     setShowPlusModal(false)
   await getAgreementsBasedOnType("CoveredByKudzuPlusTerms");
   setShowAgreementsModel(true)
  }
  else {
      navigate('/Documents/Policies/Covered%20by%20Kudzu%20Terms%20and%20Conditions', { state: { name: 'Covered by Kudzu Terms and Conditions',
        url:
        userMembershipData?.membershipType === "Plus" ||
        userMembershipData?.membershipType === "Trial"
        ? "CoveredByKudzuPlusTerms"
        : "CoveredByKudzuTerms"
         , accType: 64, CardKey: cards?.[0]?.CardKey } });
  
  }
  }


  const onAcptBtnClickPlusModal = () =>{
     if ((btn1Text === t('Begin_Free_3-Month_Trial') || btn1Text === t('get_started_With_kudzu_plus')) && btn2Text == t('No_Thanks')){
        welcomeCarouselSkipFalse()
        isSignUpBenefitsAcceptClicked()
     }
  }

  const onCancelBtnClickPlusModal = () =>{
     if ((btn1Text === t('Begin_Free_3-Month_Trial') || btn1Text === t('get_started_With_kudzu_plus')) && btn2Text === t('No_Thanks')){
      setShowPlusModal(false)
      setIsLoading(true)
      setTimeout(() => {
      setIsLoading(false)
      showAlertModalPlus(true, '', isSignUpKudzuplusTrialVal ? t('Access_exclusive_features_and_benefits') :  t('access_exclusive_features_and_benefits_with_kudzu_membership'),"", false, false, '', '', false, '', "", true, "", "", true, <ComparisonOffer handleComparisonScreen={isSignUpBenefitsAcceptClicked}  preLoginAgreement={handlePreLoginAgreement}
/>, true, false,'', <><p className={`${SubHeaderMsgStylesPlus}  mt-6`}>{t('Get_access_to_more_with_a_Kudzu+_membership')}</p><p className={HighlightMsgStylesPlus} onClick={handleCarousels}>{t('learn_more')}</p></> );
      }, 1000);
     }
  }

 

  const slidesDataForHome = [
    {
      heading: t("Receive_Direct_Deposits"),
      paragraph: (t("Direct_deposit_funds")),
      videoUrl: require('../../../../assets/videos/freeTrailVideos/kudzu-plus-ach.mp4'),
      footerTextForUpgrade: t("new_footer_signup_carousel_receive"),
      dynamicfooterStyles: "font-hanken-grotesk md:w-[454px] mt-[42px] modal-title text-[#94C3E8] text-[12px] font-[400] sm:w-[322px]"
    },
    {
      heading: addLineBreaks(t('save_with_explore_carousel')),
      paragraph: <p>{t("plan_future_para")}{" "}
        <span
          className="!text-[#94C3E8] lg:text-[17px] cursor-pointer relative inline-block"
          onClick={(e) => {
            e.stopPropagation();
            const tooltip = e.currentTarget.querySelector('.tooltip');
            if (!tooltip) return;

            const isVisible = tooltip.style.display === 'block';
            tooltip.style.display = isVisible ? 'none' : 'block';

            // Close the second tooltip if it's open
            const tooltipAPY = e.currentTarget.closest('p').querySelector('.tooltipAPY');
            if (tooltipAPY && tooltipAPY.style.display === 'block') {
              tooltipAPY.style.display = 'none';
            }

            if (!isVisible) {
              const handleClickOutside = (event) => {
                if (tooltip && !tooltip.contains(event.target)) {
                  tooltip.style.display = 'none';
                  document.removeEventListener('click', handleClickOutside);
                }
              };
              setTimeout(() => {
                document.addEventListener('click', handleClickOutside);
              }, 0);
            }
          }}

        >
          {addLineBreaks(t("Saving"))}
          <div
            className={`tooltip hidden w-[174px] font-[400] absolute left-1/2 -translate-x-1/2 top-[100%] mt-2
                                    p-[16px] bg-[#3C66FF] text-white text-[12px] rounded-xl
                                    shadow-lg z-10 cursor-pointer transition-all duration-1000`}
          >
            <div className="tooltip-arrow-comparion"></div>
            <span className="text-[14px]">{t('Savings_Goals')}</span> {t('SavingGoal_Tooltip')}
          </div>
        </span>
        <br></br>
        <span
          className="!text-[#94C3E8] lg:text-[17px] cursor-pointer relative inline-block"
        >
          {addLineBreaks(t("Goal"))}
          <div
            className={`tooltip hidden w-[174px] font-[400] absolute left-1/2 -translate-x-1/2 top-[100%] mt-2
                                p-[16px] bg-[#3C66FF] text-white text-[12px] rounded-xl
                                shadow-lg z-10 cursor-pointer transition-all duration-1000`}
          >
            <div className="tooltip-arrow-comparion"></div>
            <span className="text-[14px]">{t('Savings_Goals')}</span> {t('SavingGoal_Tooltip')}
          </div>
        </span>{" "}
        {" "}{t("para_saving_goals_sec_part")}{" "}
        <span
          className="!text-[#94C3E8] cursor-pointer relative inline-block"
          onClick={(e) => {
            e.stopPropagation();
            const tooltips = e.currentTarget.querySelector('.tooltipAPY');
            if (!tooltips) return;

            const isVisibleAPY = tooltips.style.display === 'block';
            tooltips.style.display = isVisibleAPY ? 'none' : 'block';

            // Close the first tooltip if it's open
            const tooltip = e.currentTarget.closest('p').querySelector('.tooltip');
            if (tooltip && tooltip.style.display === 'block') {
              tooltip.style.display = 'none';
            }

            if (!isVisibleAPY) {
              const handleClickOutside = (event) => {
                if (tooltips && !tooltips.contains(event.target)) {
                  tooltips.style.display = 'none';
                  document.removeEventListener('click', handleClickOutside);
                }
              };
              setTimeout(() => {
                document.addEventListener('click', handleClickOutside);
              }, 0);
            }
          }}
        >
          {t("para_saving_goals_third_part")}
          <div
            className={`tooltipAPY hidden w-[174px] font-[400] absolute left-1/2 -translate-x-1/2 top-[100%] mt-2
                                     p-[16px] bg-[#3C66FF] text-white text-[12px] rounded-xl
                                     shadow-lg z-10 cursor-pointer transition-all duration-1000`}
          >
            <div className="tooltip-arrow-comparion"></div>
            <strong className="text-[12px]">{t('APY')}</strong> {t('APY_Saving_goal')}
          </div>
        </span>
      </p>,
      dynamicSubHeaderStyles: "sm:w-[396px] font-hanken-grotesk modal-title text-white lg:text-[16px] md:text-[14px] sm:text-[10px] text-[12px]  font-[300]",
      videoUrl: require('./../../../../assets/videos/freeTrailVideos/Set_Intentions.mp4'),
      footerTextForUpgrade:t("comparison_para_four"),
      dynamicfooterStyles: "font-hanken-grotesk md:w-[454px] mt-[42px] modal-title text-[#94C3E8] text-[12px] font-[400] sm:w-[322px]"
    },
    {
      heading: addLineBreaks(t("Enable_Overdraft_Protection")),
      paragraph: <p>{t("enable_over_draft_para_trail")}</p>,
      imageUrlAlter: require('../../../../assets/kudzu-plus-images/overdraft_imag.png'),
      footerTextForUpgrade: <>{t("enabled_overdraft_updated_footer")} <span className="underline cursor-pointer" onClick={handleTermsClick}>{t('kudzu_navigate_link')}</span></>,
      dynamicfooterStyles: "font-hanken-grotesk md:w-[454px] mt-[42px] modal-title text-[#94C3E8] text-[12px] font-[400] sm:w-[322px]"
    },
    {
      heading: addLineBreaks(t("Save_On_Out_Of_NetWork_Atm")),
      paragraph: (t('We_wont_charge_on_ATM')),
      videoUrl: require('./../../../../assets/videos/freeTrailVideos/kudzu-plus-atm.mp4'),
      footerTextForUpgrade: t("free_atm_footer"),
      dynamicfooterStyles: "font-hanken-grotesk mt-[50px] modal-title text-[#94C3E8] text-[12px] font-[400] pb-12"
    },

  ];

  const handleCarousels = () =>{
     showAlertModalPlus(
                true,
                '',
                '',
                "",
                true,
                true,
                isSignUpKudzuplusTrialVal ? t('Begin_Free_3-Month_Trial') : t('get_started_With_kudzu_plus'),
                t('No_Thanks'),
                true,
                '',
                <CustomCarousel slidesData={slidesDataForHome} />,
                true,
                "",
                "",
                true,
                "",
                false,
                false
              );
  }
 const closeModelPlus = () =>{
  debugger
  if(headerMsg == t('access_exclusive_features_and_benefits_with_kudzu_membership') || headerMsg == t('Access_exclusive_features_and_benefits')){
    welcomeCarouselSkipFalse()
    // isSignUpBenefitsAcceptClicked()
    setShowPlusModal(false)
     finalApiHit(signUpkudzuPlusTrue);
  }
  else if ((btn1Text === t('Begin_Free_3-Month_Trial') || btn1Text === t('get_started_With_kudzu_plus')) && btn2Text === t('No_Thanks')){
    setShowPlusModal(false)
    setIsLoading(true)
    setTimeout(() => {
    setIsLoading(false)
    showAlertModalPlus(true, '',isSignUpKudzuplusTrialVal ? t('Access_exclusive_features_and_benefits') : t('access_exclusive_features_and_benefits_with_kudzu_membership'),"", false, false, '', '', false, '', "", true, "", "", true, <ComparisonOffer handleComparisonScreen={isSignUpBenefitsAcceptClicked}  preLoginAgreement={handlePreLoginAgreement}
/>, true, false,'', <><p className={`${SubHeaderMsgStylesPlus}  mt-6`}>{t('Get_access_to_more_with_a_Kudzu+_membership')}</p><p className={HighlightMsgStylesPlus} onClick={handleCarousels}>{t('learn_more')}</p></> );
    }, 1000);
   }
 }


  const handleDone = async () => { 
        setSuccessModalOpen(false);
        setAppDownloadModal(true)
    }

   const handleAppDownloadModalClose = () =>{
    setAppDownloadModal(false);
     navigate('/'); 
     dispatch({ type: 'FROM_SMI_ONE', payload: { fromSmiOne: false} })
 }

  return (
    <>
      <HomeLayout>

        <div className='sm:flex hidden'>
          <HomeHeader heading={<>
            <span className='font-serif-pro  text-[#2965FB] sm:text-[var(--signup-flow-heading-text)] lg:text-[31px]
            md:text-[26px] sm:text-[22px] text-[25px] lg:leading-[38px]
             md:leading-[33px] sm:leading-[29px] leading-[31px]'>{!personalInfo?.CreateSavings ? t('almost_done_title') : t('finally_comma')} </span>
           <span className='font-serif-pro sm:text-[var(--text-clr-secondary)] text-[var(--text-clr-secondary3)] lg:text-[31px]
            md:text-[26px] sm:text-[22px] text-[25px] lg:leading-[38px]
             md:leading-[33px] sm:leading-[29px] leading-[31px]'>{personalInfo?.CreateSavings ? addLineBreaks(t('please_confirm_your_social_security_number')) : t('enter_ssn_subheadingTitle')}</span>
            </>
          } isHeaderCaption={true} />
        </div>

        <div className='flex flex-col lg:w-[860px] md:w-[860px] sm:w-[464px] w-[100%]
       animate__animated animate__fadeInRight '>
          <DynamicCard
            header={false}
            footer={false}
            CardRadius={true}
            HeaderRadius={true}
            mblCardRadius={true}
            backgroundColor={"--modalcard-bg"}
            isWhiteForSignup={appThemeData.isWhiteBgForCard}
            isDarkForKudzu={appThemeData.isDarkBgForCard}
            cardWidth={width.homeCard}>
            {/* style={{ display: 'flex', flexDirection: 'column', minHeight: '560px', width: '75%', justifyContent: 'center', alignItems: 'start', alignSelf: 'center' }}  */}
            <div className='sm:d-flex flex-col sm:min-h-[560px] sm:w-[75%] sm:justify-center sm:items-center sm:self-center mx-auto mt-10'>
              <div className='flex flex-col justify-between' style={{ minHeight: '560px', width: "100%" }}>


                <div className="sm:hidden block lg:my-[2rem] md:my-[1.5rem] my-[1.5rem] font-[500] lg:text-[32px] md:text-[28px]
                                 sm:text-[23px] text-[27px] lg:leading-[38px] md:leading-[32px] sm:leading-[30px] leading-[32px] font-serif-pro w-[260px] 
                                 h-auto mb-[2rem] sm:px-0 px-4">
                  <p className='text-[#2965FB]'>{!personalInfo?.CreateSavings ? t('great_exclamation') : t('finally_comma')}
                    <span className={`${appThemeData ? "" : "sm:text-[#2965FB] md:text-[#2965FB]"} text-[var(--text-personal-infos)]`}> {personalInfo?.CreateSavings ? addLineBreaks(t('please_confirm_your_social_security_number')) : t('enter_ssn_subheadingTitle')}</span>
                  </p>
                </div>

                <div className="sm:block hidden lg:my-[2rem] md:my-[1.5rem] my-[1.5rem] font-[500]  text-[var(--modal-text-heading-clr)]
                     lg:text-[32px] md:text-[28px] sm:text-[23px] text-[27px] lg:leading-[38px] md:leading-[32px] sm:leading-[30px] leading-[37px] font-serif-pro w-full 
                        sm:mx-0 mx-4"> {t('social_security_number')}</div>





                {/* <div className='border-t-[2.5px] w-full border-[#A3CEBB] 
                        flex justify-center sm:mx-0 mx-4'></div> */}
                <div className='flex flex-row w-full'>
                  <div className="sm:w-full md:w-4/5 lg:w-4/5 mt-[4rem] w-full"
                    onFocus={() => { toggleCursor() }}
                    onBlur={() => { toggleCursor() }}
                  >
                    <div className="flex items-center relative">
                      <span
                        type="button"
                        className="text-gray-500 absolute right-4 top-5"
                        onClick={togglePasswordVisibility}
                      >
                        {showSSN ? <img src={appThemeData.Showpassword} className='w-[20px] h-[20px] cursor-pointer' /> : <img src={HideSSNPic} className='w-[20px] h-[20px] cursor-pointer' />}
                      </span>
                      <input
                        ref={ssnRef}
                        onPaste={handlePaste}
                        id={'ssn_no'}
                        {...register('ssn_no')}
                        value={SSNBackupSecondary}
                        placeholder={'Social Security Number (SSN)'}
                        className={`${InputStyles} text-[var(--input-text1)]  bg-[var(--input-bg)] placeholder-[var(--input-text1)] ${showSSN ? 'password-input' : ''}`}
                        autoComplete="off"
                        onChange={handleSSNChange}
                        maxLength={9}
                        style={{ color: 'transparent', caretColor: 'transparent' }}

                      // value={ssn}
                      // onKeyUp={handleInputChange}
                      >
                      </input>
                    </div>
                    <div className='flex z-[999] opacity-100 relative top-[-51px] h-[60px] w-[80%] 
            bg-transparent items-center'

                      style={{ position: 'relative', top: -48 }}
                      onClick={() => {
                        const input = document.getElementById("ssn_no");
                        input.focus()
                      }}>
                      <p className='h-[50px] no-underline ml-[15px] top-[10] text-[var(--input-text1)]' >{ssn}{isCursorVisible && <span style={{ display: 'inline-block', animation: isCursorVisible ? 'blink 0.8s step-end infinite' : 'none', verticalAlign: 'text-bottom', color: '#2965FB', fontWeight: '200', fontSize: '15px' }}>|</span>}</p>
                    </div>

                  </div>
                  <style>{`@keyframes blink {0%, 100% {opacity: 1;}50% {opacity: 0;}}`}</style>
                  <div className="w-[10%] ml-4 flex items-center align-center">{(isSSNValid && isSSNTouched) && <img className='' src={Check} alt="Check" />}</div>
                </div>

                {errors.ssn_no &&
                  <div className={` -mt-16 sm:-mt-32 md:-mt-16 mb-2 pb-[3rem]`}>
                    {displayErrorMessage(errors.ssn_no.message)}
                  </div>
                }
                {personalInfo?.CreateSavings &&
                  <div>
                    <div class="flex lg:mb-[2rem] md:mb-[2rem] mb-[2rem]" >
                      <input
                        id="deposit-savings-checkbox"
                        ref={checkbox1Ref}
                        type="checkbox"
                        class="checkbox-round md:mt-[6px] mt-[4px]"
                        onKeyDown={(event) => {
                          if (event.key === 'Enter') {
                            event.preventDefault();
                            setTermsAccepted(!termsAccepted); if (!termsAccepted) { setErrorMessage(''); button1Ref.current.focus(); }
                          }
                        }}
                        value=""
                        tabIndex="0"
                        checked={termsAccepted}
                        onChange={(event) => { setTermsAccepted(!termsAccepted); if (!termsAccepted) { setErrorMessage(''); button1Ref.current.focus(); }; }}
                      />
                      <label for="deposit-savings-checkbox" class="font-hanken-grotesk   text-[var(--modal-text-heading-clr)] ml-4 sm:ml-2 md:ml-4 md:text-sm sm:text-[12px] text-[14px] font-medium">{t('under_penalty_of_perjury_iwill_clarify')}
                      </label>
                    </div>
                    <p className='ml-14 md:text-sm  text-[var(--modal-text-heading-clr)] sm:text-[12px] text-[14px] font-hanken-grotesk font-medium ' dangerouslySetInnerHTML={{ __html: t('under_penalty_of_perjury_ssn').replace(/\n/g, "<br />") }}></p>
                    {/* <style>
                                            {`p br {display: block;margin-bottom: 100px;}`}
                                        </style> */}
                  </div>
                }
                {errorMessage &&
                  <div className={`mt-2 mb-2 pb-[2rem]`}>
                    {displayErrorMessage(errorMessage)}
                  </div>
                }
                {personalInfo?.CreateSavings &&
                  <p className="lg:my-[4rem] mt-20 md:my-[4rem]  text-[var(--modal-text-heading-clr)]  my-[4rem] md:text-sm sm:text-[12px] text-[14px] font-hanken-grotesk  sm:mx-0 mx-4 sm:font-medium font-[600] sm:w-auto w-[290px]">
                    {t('by_tapping_continue_i_understand')}
                  </p>
                }
                <div className='lg:my-[4rem] md:my-[4rem] my-[4rem] flex flex-row justify-end lg:mt-20 md:mt-16 sm:mt-6 sm:mx-0 mx-4 lg:mb-10:mb-6 mb-5'>
                  <button
                    type="button"
                    // autoFocus
                    ref={button1Ref}
                    // tabIndex={1} 
                    className={`font-hanken-grotesk sm:font-bold font-[600]
                                lg:text-[18px] md:text-[17px] sm:text-[14px] text-[16px]
                                 ${isSSNValid ? 'text-[var(--habit-add-clr)]' : 'text-[var(--ssn-disabled-continue)]'}
                                 cursor-pointer flex items-center`}
                    onClick={() => { handleConfirm() }}
                    onKeyDown={(event) => {
                      if (event.key === "Enter") {
                        event.preventDefault();
                        handleConfirm()
                      }
                    }}
                  >
                    {t('continue')} 
                    <img
                      src={isSSNValid ? appThemeData.arrowWhiteTwofac : appThemeData.ArrowKudzuTo }
                      className="md:w-[14px] sm:w-[11px] md:h-[14px] sm:h-[11px] w-[14px] h-[14px] ml-1"
                      style={{opacity: signUpkudzuPlusTrue ? (isSSNValid ? 1 : 0.5 ) : '' }}
                      alt="Arrow" />
                  </button>
                </div>
              </div>
            </div>

          </DynamicCard>

        </div>
        <Modal
          isOpen={isRegisterSucessModalOpen}
          onClose={closeRegisterSuccessModal}
          isLogo={false}
          title={null}
          subtitle={null}
          content={<div>

            <RegisterSuccessModal
              //  subtitle={personalInfo?.CreateSavings == true ?
              //    t('spending_saving_account_ready') : t('spending_account_ready')}

              subtitle={
                signUpkudzuPlusTrue
                  ? isSignUpKudzuplusTrialVal  ?
                   personalInfo?.CreateSavings ? addLineBreaks(t("You_spending_and_savings_Kudzu+_membership")): addLineBreaks(t("your_spending_account_is_approved_and_ready_to_use_trial")) 
                    : personalInfo?.CreateSavings
                      ? t(
                        "your_spending_and_saving_accounts_are_approved_plus"
                      )
                      : t("your_spending_account_is_approved_and_ready_to_use_plus")
                    : personalInfo?.CreateSavings 
                    ? t("spending_saving_account_ready")
                    : t("spending_account_ready")
              }
            />
          </div>

          }
        />
        <CustomAlertModel
          isOpen={showModel}
          onClose={closeModel}
          image={modelImage}

          highlightMsg={headerMsg == t('reviewing_profile') ?
            <p className='font-serif-pro modal-title  sm:flex block flex-col
                lg:text-[32px] md:text-[28px] sm:text-[23px] text-[27px] lg:leading-[38px] md:leading-[32px]
                 sm:leading-[30px] leading-[37px] font-normal text-[#2965FB] cursor-pointer pointer-events-none'>{highlightMsg}

              {headerMsg == t('reviewing_profile') ? <span className={`md:w-[287px] sm:w-[200px] font-serif-pro modal-title
                lg:text-[32px] md:text-[28px] sm:text-[23px] text-[27px] lg:leading-[38px] md:leading-[32px] sm:leading-[30px]
                leading-[37px] font-normal cursor-pointer pointer-events-none ${appThemeData ? "" : "sm:text-[#2965FB] md:text-[#2965FB]"} text-[var(--text-personal-infos)]`}> {headerMsg}</span> : <span className={HeaderMsgStyles}>
                {headerMsg}</span>} </p> :
            <p className={HighlightMsgStyles}>{highlightMsg}</p>}


          HeaderMsg={headerMsg != t('reviewing_profile') && <p className={`${HeaderMsgStyles} md:w-[357px] sm:w-[335px]`}>{headerMsg}</p>}

          subHeaderMsg={
            <>
              {subHeaderMsg == t('please_contact') ?
                <p className={FailSubHeaderMsgStyles}>{t("please_contact")}
                  {<button onClick={() => {
                    window.open(CONTACT_US_URL, '_blank');
                  }} className='font-hanken-grotesk lg:text-[20px] md:text-[18px] sm:text-[14px] text-[16px] text-[#2965FB] font-semibold cursor-pointer'>
                    {t("signup_customer_care")}
                  </button>}
                  {t("for_access")}
                </p>
                :

                subHeaderMsg == t('please_join') ?
                  <p className={FailSubHeaderMsgStyles}>{t("please_join")}
                    {<button onClick={() => {
                      window.open(CONTACT_US_URL, '_blank');
                    }} className='font-hanken-grotesk lg:text-[20px] md:text-[18px] sm:text-[14px] text-[16px] text-[#2965FB] font-semibold cursor-pointer'>
                      {t("signup_customer_care")}
                    </button>}
                    {t("for_access")}
                  </p>
                  :
                  <p className={SubHeaderMsgStyles}>{subHeaderMsg}</p>

              }
            </>
          }

          btn1Exists={btn1Exists}
          btn2Exists={btn2Exists}
          btn1Text={btn1Text} btn2Text={btn2Text}
          btn1TypeAcpt={btn1TypeAcpt}
          verificationFailure={() => { }}
          footerMsg={<p className={SubHeaderMsgStyles}>{footerMsg}</p>}
          onAcptBtnClick={onAcptBtnClick}
          onCancelBtnClick={onCancelBtnClick}
        />
         <CustomModalPlus isOpen={showPlusModal} onClose={closeModelPlus} onBack={closeModelPlus}
        image={modelImage}
        carousel={carousel}
        comparisonScreen={comparisonScreen}
        summaryParagraph={summaryParagraph ? <p className={summaryParagraphStyles}>{summaryParagraph}</p> : ""}
        isBorderNone={isBorderNone}
        highlightMsg={<p className={HeaderMsgStylesplus}> {headerMsg}</p>}
        subHeaderMsg={ <p className={SubHeaderMsgStylesPlus}>{subHeaderMsg}</p> }
        btn1Exists={btn1Exists}
        btn2Exists={btn2Exists}
        btn1Text={btn1Text}
        btn1BgColor={btn1BgColor}
        btn2Text={btn2Text}
        opacityLow={opacityValueLow}
        defaultCornerRadius={false}
        btn1TypeAcpt={btn1TypeAcpt}
        fullWidth={fullWidth}
        onAcptBtnClick={onAcptBtnClickPlusModal}
        onCancelBtnClick={onCancelBtnClickPlusModal }
        footerButtonEnable={footerButtonEnable}
        allButtonsDisable={allButtonsDisable}
        subHeadingForCarousel={subHeadingForCarousel}
      />
        {isLoading && <Loader />}
      </HomeLayout>
      <Suspense fallback={<div>Loading...</div>}>
          <Modal
        isIframe={true}
        isOpen={showAgreementsModel}
        onClose={() => {
          setShowAgreementsModel(false);
        }}
        title={false}
        content={
          <div
            className="w-full h-full   md:pt-0 sm:pt-6  pt-16"
            style={{ height: window.innerHeight }}
          >
            <iframe
              src={policyURL}
              id="policyIframe"
              title="Embedded Website"
              className="w-full"
              style={{ height: window.innerHeight }}
            />
          </div>
        }
      />
      </Suspense>
      <Modal
                  isOpen={successModalOpen}
                  onClose={handleDone}
                  defaultCornerRadius={false}
                  isLogo={false}
                  title={<p className="font-serif-pro modal-title sm:text-[18px] lg:text-[32px] md:text-[28px] text-[25px] sm:leading-[24px] lg:leading-[38px] md:leading-[33px] leading-[31px] font-normal text-[#2965FB] hidden sm:flex">{t('success')}</p>}
                  subtitle={ <p>
                      <span className="font-serif-pro modal-title sm:text-[18px] lg:text-[32px] md:text-[28px] text-[25px] sm:leading-[24px] lg:leading-[38px] md:leading-[33px] leading-[31px] font-normal text-secondary-3">{addLineBreaks(t('your_smiOne_card'))}</span>
                  </p>}
                  content={
                      <div class="aspect-454/253 md:mt-10 sm:mt-6 mt-6"><SmiOneRegistrationSuccessModal  handleDone ={handleDone}  /></div>
                  }
                  />
                  <Modal
                              isOpen={appDownloadModal}
                              onClose={handleAppDownloadModalClose}
                              defaultCornerRadius={false}
                              isLogo={false}
                              // title={<p className={`${HeadingStyles} hidden sm:flex`}>{t('success')}</p>}
                              subtitle={ <p className='w-[224px] sm:w-[391px]'>
                                  <span className={SubHeadingStyles}>{<span>{t('Download_the')} <span className='text-[#2965FB]'>{t('Kudzu')}</span> {t('mobile_app')}</span>}</span>
                              </p>}
                              content={ 
                                  <div class="aspect-454/253 md:mt-10 sm:mt-6 mt-6">
                                              <div className='flex flex-col justify-center items-center w-full'>
                                   
                                  <img src={MobileIcon} alt="complete" className=' w-[250px] mb-5' />
                                  <div className='flex flex-col justify-center items-center w-full'>
                  
                                  <div className=' flex flex-col  my-5 w-full'>
                                      <div className='flex flex-row justify-center mt-3 items-center gap-7 w-full'>
                                  <button className="focus:outline-none flex items-center justify-center  gap-2   bg-[#2965FB] text-[14px] w-full 
                                  text-[#fff] font-[600] h-[60px] border-2 border-[#2965FB]" onClick={() => window.open('https://apps.apple.com/us/app/kudzu-money/id6449820905', '_blank')} >
                                    
                                      <img src={ App_Store} alt='' className='w-[16px] ml-2 '/> <span>{t('Download for iPhone')}</span> 
                                      </button>
                                  <button className="focus:outline-none flex items-center justify-center gap-2  bg-[#2965FB] text-[14px] w-full 
                                  text-[#fff] font-[600] h-[60px] border-2 border-[#2965FB]" onClick={()=> window.open('https://play.google.com/store/apps/details?id=com.kudzumoneyllc.kudzu')}>
                                       
                                   <img src={Play_Store} className=' w-[16px] ml-2'/>  <span> {t('Download for Android')} </span>
                                      </button>
                                      </div>
                                      <button className="focus:outline-none  text-[16px] w-full 
                                  text-[#2965FB] font-[600] h-[60px] border-none mt-4  " onClick={()=>{setAppDownloadModal(false); navigate('/'); dispatch({ type: 'FROM_SMI_ONE', payload: { fromSmiOne: false} })}}>
                                      
                                      {t('May be later')} 
                                      </button>
                                  </div>
                                  </div>
                  
                                  </div>
                                  </div>
                              }
                              />
      
    </>
  )
}

export default FinalRegistrationThroughSSN;
